import * as React from "react";
import { isEmpty } from "lodash";
import { compose, graphql } from "react-apollo";
import gql from "graphql-tag";

type Props = {
  exportInstructionId: Number;
  exportFile: any;
  fetchingData: Boolean;
  error: Boolean;
  setFetchingData: Function;
  setError: Function;
  setExportInstructionId: Function;
};

class FileExportStatus extends React.Component<Props> {
  componentDidUpdate() {
    // Stop polling
    if (
      this.props?.exportFile?.export_file?.[0]?.status === "completed" &&
      this.props.fetchingData
    ) {
      this.props.exportFile.stopPolling();
      this.props.setFetchingData(false);
      this.props.setError(false);
      this.openExportFile(this.props?.exportFile?.export_file?.[0]?.file);
    }

    // Start polling
    if (
      isEmpty(this.props?.exportFile?.export_file?.[0]?.file) &&
      this.props.fetchingData
    ) {
      this.props.exportFile.startPolling(5000);
    }

    // Show error
    if (
      this.props?.exportFile?.export_file?.[0]?.status === "error" &&
      this.props.fetchingData
    ) {
      this.props.exportFile.stopPolling();
      this.props.setFetchingData(false);
      this.props.setError(true);
      this.props.setExportInstructionId(null);
    }
  }

  openExportFile = (exportUrl) => {
    // Open export url in new window
    const newWindow = window.open(exportUrl, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  render() {
    return <span>Downloading File...</span>;
  }
}

const getExportQuery = graphql(
  gql`
    query exportFile($id: ID!) {
      export_file(id: $id) {
        file
        status
      }
    }
  `,
  {
    name: "exportFile",
    options: (props: any) => {
      return {
        fetchPolicy: "network-only",
        variables: {
          id: props.exportInstructionId,
        },
      };
    },
  }
);

export default compose<any>(getExportQuery)(FileExportStatus);
